import React from "react";
import { FormattedMessage } from "react-intl";

import { SectionHeader } from "../../../sectionHeader/SectionHeader";

export const ScheduleCategoriesHeader = () => {
  return (
    <SectionHeader
      description={<FormattedMessage id={"web_filter_option_description"} />}
    >
      <h4>
        <FormattedMessage id={"web_filter_option"} />
      </h4>
    </SectionHeader>
  );
};
